<script lang="ts">
  // One place for the three async states a view can be in. Keeps loading / error
  // / empty visually consistent everywhere.
  let {
    state,
    message = null,
    hint = null,
    onretry = null,
    compact = false,
  }: {
    state: 'loading' | 'error' | 'empty';
    message?: string | null;
    hint?: string | null;
    onretry?: (() => void) | null;
    compact?: boolean;
  } = $props();
</script>

<!-- `compact` is the side panel's density as much as its padding: at 340px the
     roomy spinner and the tall block both crowd the thing they are describing. The
     two copies of this file differed in exactly that and nothing else, so the prop
     that already existed carries it instead of one surface losing its spacing. -->
<div class="flex flex-col items-center justify-center gap-2 text-center {compact ? 'py-8' : 'flex-1 py-16'}">
  {#if state === 'loading'}
    <span class="loading loading-spinner {compact ? 'loading-md' : 'loading-lg'} text-primary/70"></span>
  {:else if state === 'error'}
    <div class="eyebrow text-error/80">Something went wrong</div>
    <p class="max-w-sm text-sm text-base-content/72">{message ?? 'Could not load this view.'}</p>
    {#if onretry}<button class="btn btn-sm mt-1" onclick={onretry}>Retry</button>{/if}
  {:else}
    <div class="eyebrow">{message ?? 'Nothing here yet'}</div>
    {#if hint}<p class="max-w-sm text-sm text-base-content/72">{hint}</p>{/if}
  {/if}
</div>
